$(document).ready(() => {
  $('[data-add-class]').on('click', function(ev){
    let obj = JSON.parse($(this).attr('data-add-class'));
    if (obj['target'] && obj['addClass']){
      $(obj['target']).addClass(obj['addClass']);
    }
  });

  $('[data-focus]').on('click', function(ev){
    let obj = JSON.parse($(this).attr('data-focus'));
    if (obj['target']){
      $(obj['target']).focus();
    }
  });
});